import { useState } from "react";
import { motion } from "framer-motion";
import { X, Heart } from "lucide-react";
import { ProductCard } from "./ProductCard";
import { QuickView } from "./QuickView";

export const Wishlist = ({ products, favorites, onToggleFavorite, onClose }) => {
  const [quickView, setQuickView] = useState(null);
  const favs = products.filter((p) => favorites.includes(p.id));

  return (
    <motion.div
      data-testid="wishlist-panel"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] overflow-y-auto bg-[#0B0C0E]/95 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FFB800]">Saved by you</p>
            <h2 className="mt-2 font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-50">
              My Wishlist <span className="font-mono text-lg text-slate-500">({favs.length})</span>
            </h2>
          </div>
          <button
            data-testid="wishlist-close-btn"
            onClick={onClose}
            aria-label="Close wishlist"
            className="rounded-full border border-white/10 bg-[#121418] p-2.5 text-slate-300 transition-colors hover:bg-[#FF9900] hover:text-[#0B0C0E]"
          >
            <X size={18} />
          </button>
        </div>

        {favs.length === 0 ? (
          <div className="mt-24 flex flex-col items-center gap-4 text-center">
            <Heart size={40} className="text-slate-700" />
            <p data-testid="wishlist-empty-state" className="max-w-sm text-sm text-slate-400">
              Nothing saved yet. Tap the heart on any product to keep it here for later.
            </p>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
            {favs.map((p, i) => (
              <ProductCard
                key={p.id}
                product={p}
                index={i}
                onQuickView={setQuickView}
                isFavorite
                onToggleFavorite={onToggleFavorite}
              />
            ))}
          </div>
        )}
      </div>
      <QuickView product={quickView} onClose={() => setQuickView(null)} />
    </motion.div>
  );
};
